<template>
  <div
    class="button"
    tabindex="0"
    @click="buttonClick"
    @keyup.space="buttonClick"
    v-text="buttonLabel"
  />
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    methods: VueTypes.string.def("click"),
    buttonLabel: VueTypes.string.isRequired,
    index: VueTypes.isRequired,
    disable: VueTypes.bool.def(false)
  },
  methods: {
    buttonClick: function() {
      if (!this.disable) {
        this.$emit(this.methods, this.index);
      }
    }
  }
};
</script>

<style scoped>
.button {
  border-radius: 5px;
  border: 2px solid #d8d8d8;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button:hover {
  cursor: pointer;
}
</style>
